export default __webpack_public_path__ + "static/media/logo.277fb6b8.png";